import { POST } from '@/api'
import statusMap from '@/resources/reservation/statusMap'

export default {
  namespaced: true,
  state: {
    pagenation: {},
    reservation: [],
    isReservationListBusy: true,
    isReservationListEnd: false,
    requestPdf: {
      startDate: '',
      endDate: '',
    },
    isSendPdfBusy: false,
    isSentPdf: false,
  },
  mutations: {
    updatePagenation(state, value) {
      state.pagenation = value
    },
    updateReservation(state, value) {
      state.reservation = value
    },
    reservationListBusy(state, value) {
      state.isReservationListBusy = value
    },
    reservationListEnd(state, value) {
      state.isReservationListEnd = value
    },
    updatePdfStartDate(state, value) {
      state.requestPdf.startDate = value
    },
    updatePdfEndDate(state, value) {
      state.requestPdf.endDate = value
    },
    sendPdfBusy(state, value) {
      state.isSendPdfBusy = value
    },
    updateSentPdf(state, value) {
      state.isSentPdf = value
    },
    updateReservationStatus(state, { reservationId, statusId }) {
      const index = state.reservation.findIndex(reserve => reserve.rsvId === reservationId)
      if (statusId === 1) {
        state.reservation.splice(index, 1)
      } else {
        state.reservation[index].status = statusMap[statusId]
      }
    },
  },
  actions: {
    async get(store, { timeZone, startDate, endDate, readonly = false }) {
      const { commit, state } = store
      commit('reservationListBusy', true)
      if (state.isReservationListEnd) commit('reservationListEnd', false)

      const { status, message, data } = await POST('/api/web/reservation/list', {
        timeZone,
        startDate,
        endDate,
        start: state.reservation.length,
        limit: 20,
        readonly,
      })

      if (status !== 200) {
        commit('updatePagenation', { total_count: 0 })
        commit('updateReservation', [])
        commit('reservationListEnd', true)
      }
      if (status !== 200 && status !== 404) commit('app/error', { status, message }, { root: true })

      if (data && status === 200) {
        // 予約日(index)を追加して配列に再生成
        const list = Object.keys(data.reservation).reduce(
          (ary, index) => ary.concat(data.reservation[index].map(reserve => Object.assign(reserve, { index }))),
          [],
        )

        commit('updatePagenation', data.pagenation)
        commit('updateReservation', state.reservation.concat(list))
        if (!data.pagenation.next) commit('reservationListEnd', true)
      }

      commit('reservationListBusy', false)

      // 一覧表示されている期間をPDF用にセット
      commit('updatePdfStartDate', startDate)
      commit('updatePdfEndDate', endDate)

      return status === 200
    },
    async sendPdf(store, { timeZone, formatType, withCustomer }) {
      const { state, commit } = store
      if (state.isSendPdfBusy) return
      commit('sendPdfBusy', true)

      const { startDate, endDate } = state.requestPdf
      const { status, message } = await POST('/api/web/reservation/list/send_pdf', {
        timeZone,
        startDate,
        endDate,
        formatType,
        customerInfoGetFlg: withCustomer,
      })

      if (status === 200) {
        commit('updateSentPdf', true)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('sendPdfBusy', false)
    },
  },
}
